export const IMPORT_JB_TEMPLATES_STORAGE_KEY = 'import_jb_templates';
export const IMPORT_FU_TEMPLATE_STORAGE_KEY = 'hb_import_fu_template';
export const IMPORT_PUBLIC_TEMPLATE_STORAGE_KEY = 'import_public_template';
export const SHOULD_REDIRECT_TO_HOME_STORAGE_KEY = 'should_redirect_to_home';
export const SHOW_THE_KNOT_INTEGRATION_MODAL =
    'show_the_knot_integration_modal';
